import { API_ERROR_CODES, ApiError } from "@/api/client";

/**
 * How a failed load should be presented. Pure: no React, no fetch, no bridge —
 * the screen only renders what this returns.
 */
export type FailureView = {
  readonly title: string;
  readonly description: string;
  readonly action: "retry" | "back";
};

export function describeFailure(error: unknown): FailureView {
  if (!(error instanceof ApiError)) {
    return {
      title: "เกิดข้อผิดพลาด",
      description: "กรุณาลองใหม่อีกครั้ง",
      action: "retry",
    };
  }

  switch (error.code) {
    case API_ERROR_CODES.network:
      return {
        title: "เชื่อมต่อไม่ได้",
        description: "กรุณาตรวจสอบการเชื่อมต่ออินเทอร์เน็ตแล้วลองใหม่อีกครั้ง",
        action: "retry",
      };
    case API_ERROR_CODES.unauthorised:
      return {
        title: "เซสชันหมดอายุ",
        description: "กรุณาเข้าสู่ระบบใหม่อีกครั้ง",
        action: "back",
      };
    case API_ERROR_CODES.business:
      return {
        title: "ไม่สามารถแสดงข้อมูลได้",
        description: error.message,
        action: "retry",
      };
    case API_ERROR_CODES.http:
    case API_ERROR_CODES.invalidResponse:
      return {
        title: "ระบบขัดข้อง",
        description: "กรุณาลองใหม่อีกครั้งในภายหลัง",
        action: "retry",
      };
  }
}
